// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__2DkXo","spin":"Loader_spin__jvlh4"};